webpackJsonp([245123762025081],{

/***/ 1553:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/lowdamage/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-lowdamage-ac59dfcb30e2e279551d.js